import { api, PartipostApiResponse, PartipostApiPaginationWrapper } from './'
import {
    BrandState,
    CreateBrandRequestPayload,
    UpdateBrandRequestPayload,
    BrandRequestPayload,
} from '../../state/brands'

export interface BrandsRequest {
    url?: string
    limit?: number
    keyword?: string
    country?: string
}

export type BrandsResponse = PartipostApiPaginationWrapper<BrandState[]>

export const getBrand = (payload: BrandRequestPayload) => {
    const { uuid } = payload
    return api.get<PartipostApiResponse<CreateBrandResponse>>(`brands/${uuid}`)
}

export const getBrands = (payload: BrandsRequest) => {
    const { url, ...rest } = payload
    if (!rest.keyword) {
        delete rest?.keyword
    }
    const baseUrl = url ? url.replace('http:', 'https:') : 'brands/'
    return api.get<PartipostApiResponse<BrandsResponse>>(baseUrl, rest)
}

export type CreateBrandResponse = BrandState

export const createBrand = (payload: CreateBrandRequestPayload) => {
    return api.post<PartipostApiResponse<CreateBrandResponse>>('brands/', payload)
}

export const updateBrand = (payload: UpdateBrandRequestPayload) => {
    const { uuid, ...rest } = payload
    return api.patch<PartipostApiResponse<CreateBrandResponse>>(`brands/${uuid}/`, rest)
}
